export const initialValues = {
    value: '',
};

export const emailData = {
    status: 'Оформлен',
    orderContent: ['Код товара: 596407, lock343s - 5 шт.'],
    totals: [
        'Сумма товаров: 1245 руб.',
        'Сумма доставки: 20 руб.',
        'Общая сумма: 1265 руб.',
    ],
    deliveryAddress: [
        'Alexander Alexandrovich',
        'ru',
        'Russia, Dudinka, Krishov st., 61, 58',
        '241014',
    ],
    comment: 'Пришлите самого красивого курьера.',
};
